import { FC } from 'react'
import { TextSecure, TextBold } from './secure-copy.styled'
import { ReactComponent as LockIcon } from '../../../../assets/lock.svg'
import { useTranslation } from 'react-i18next'

export const SecureCopy: FC = () => {
  const { t } = useTranslation()

  return <TextSecure>
    <span>
      <LockIcon />
      {t('Secure payment with')} <TextBold>YUNO</TextBold>
    </span>
  </TextSecure>
}
